<template>
  <section class="form-list">
    <el-form
        class=" form form-extra-large"
        ref="form"
        :rules="rules"
        :model="reservation"
        label-position="right"
        label-width="130px"
    >
      <el-form-item label="课程门店">
        <span class="title">{{course.store_name}}</span>
      </el-form-item>

      <el-form-item label="课程名称">
        <span class="title">{{course.course_name}}</span>
      </el-form-item>

      <el-form-item label="课程老师">
        <v-avatar-nickname
            v-for="v in course.teachers"
            :key="v.avatar"
            :value="v.avatar"
            :nickname="v.nickname"
            class="avatar-item"
        />
      </el-form-item>

      <el-form-item label="课程时间">
        <span class="title">{{course.date}} {{course.start_time}} ~ {{course.end_time}}</span>
      </el-form-item>

      <el-form-item label="扣卡次数">
        <span class="title">
          <span class="primary-color count-number">{{course.decrement_number}}</span> 次
        </span>
      </el-form-item>

      <el-form-item label="预约统计">
        <v-page-reservation-list :value="course"/>
      </el-form-item>

      <el-form-item label="试课学员" prop="student_id">
        <v-select-student v-model="reservation.student_id"/>
      </el-form-item>

      <el-form-item label="付款方式" prop="card_payment_mode_id">
        <v-select-card-payment-mode v-model="reservation.card_payment_mode_id"/>
      </el-form-item>

      <v-input-you-zan-number
          v-model="reservation.you_zan_number"
          :card-payment-mode-id="reservation.card_payment_mode_id"
          @actualPaymentChange="actual_payment => reservation.actual_payment = actual_payment"
      />

      <el-form-item label="实际付款" prop="actual_payment">
        <v-input-money
            v-model="reservation.actual_payment"
            placeholder="请输入课卡实际付款"
            :is-show-suffix="true"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即试课</el-button>
        <el-button @click="RouteConfig.courseList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show } from '@/api/course';
import { store } from '@/api/course-reservation';
import { toCent, toYuan } from "@/utils/number";

const defaultReservation = {
  course_id: 0,
  student_id: '',
  card_payment_mode_id: '',
  you_zan_number: '',
  actual_payment: '',
};

export default {
  name: RouteConfig.courseTrial.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    course: {
      date: '',
      start_time: '',
      end_time: '',
      student_number: '',
      student_count: '',
      signed_count: '',
      trial_count: '',
      wait_count: '',
      course_name: '',
      decrement_number: '',
      store_name: '',
      teachers: [],
      students: [],
    },
    reservation: { ...defaultReservation },
    rules: {
      student_id: [{ required: true, message: '请选择所属学员', trigger: 'change' }],
      card_payment_mode_id: [{ required: true, message: '请选择付款方式', trigger: 'change' }],
      you_zan_number: [{ required: true, message: '请输入有赞券码', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      if (data.decrement_number) data.decrement_number = toYuan(data.decrement_number);
      const { course } = this;
      Object.keys(data).forEach(key => {
        if (key in course) course[key] = data[key];
      });
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { ...postData } = this.reservation;
        postData.is_trial = 1;
        postData.course_id = this.id;
        postData.actual_payment = toCent(postData.actual_payment);

        this.isSaving = true;
        const { isError } = await store(postData);
        this.isSaving = false;
        if (isError) return;

        this.$message({
          message: '试课成功！',
          type: 'success',
          duration: 3000,
        });
        this.reservation = { ...defaultReservation };
        this.show();
      });
    },
  },
};
</script>

<style src="./reserve.css" scoped/>
